export default __webpack_public_path__ + "static/media/close.a9306d17.svg";